export default __webpack_public_path__ + "static/media/nodejs.07d152a8.png";